module.exports = __webpack_public_path__ + "img/Group-Chat.72094472.png";